import { render } from "./TodoCardNewLogin.vue?vue&type=template&id=65169a70"
import script from "./TodoCardNewLogin.vue?vue&type=script&lang=js"
export * from "./TodoCardNewLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__